import useSWR from 'swr'
import { ParticipantController } from '@/controllers'
import { config } from '@/config'
import { useMemo } from 'react'

const key = config.api.endpoints.participant.metrics

export const useParticipantsMetrics = (hasParticipants: boolean) => {
  const {
    data,
    mutate,
    error: uncaughtError,
    isLoading,
    isValidating,
  } = useSWR(hasParticipants ? key : null, () => ParticipantController.metrics())
  const memoizedData = useMemo(() => {
    const metrics = data?.result?.[1] || {}
    const error = data?.result?.[0] || uncaughtError

    return { metrics, error }
  }, [data, uncaughtError])

  const revalidate = async () => {
    if (!hasParticipants) return
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate participants metrics')
    }

    return response.result
  }

  return {
    ...memoizedData,
    isLoading,
    revalidate,
    isValidating,
  }
}
